/* Lisa Kookt - kop blijft kort (Ingredienten/Voedingswaarden); volledige titel met producttitel verschijnt BOVENIN de opengeklapte inhoud (25-07-2026, test) */
(function () {
  'use strict';
  if (!/\/products\//.test(location.pathname)) return;
  var TARGETS = ['Ingrediënten', 'Voedingswaarden'];

  function getProductTitle() {
    var el = document.querySelector('.product__title');
    if (el) {
      var h = el.matches('h1') ? el : el.querySelector('h1');
      var t = (h || el).textContent.trim();
      if (t) return t.split('\n')[0].trim();
    }
    var h1 = document.querySelector('main h1');
    return h1 ? h1.textContent.trim() : '';
  }

  function run() {
    var title = getProductTitle();
    if (!title) return;
    var heads = document.querySelectorAll('.accordion__title');
    heads.forEach(function (h) {
      var base = h.textContent.trim();
      if (TARGETS.indexOf(base) === -1) return;
      var det = h.closest('details') || h.closest('.accordion') || h.parentElement;
      if (!det) return;
      var content = det.querySelector('.accordion__content');
      if (!content) { var s = h.closest('summary'); if (s) content = s.nextElementSibling; }
      if (!content) return;
      var full = base + ' ' + title;
      var existing = content.querySelector('.lk-acc-fulltitle');
      if (existing) { existing.textContent = full; return; }
      var p = document.createElement('p');
      p.className = 'lk-acc-fulltitle';
      p.textContent = full;
      p.style.cssText = 'font-weight:600;font-size:16px;margin:0 0 12px;';
      content.insertBefore(p, content.firstChild);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  setTimeout(run, 600);
})();

/* Lisa Kookt - staffel/volumekorting prijzen laten meelopen met de gekozen variant (25-07-2026, test) */
(function () {
  'use strict';
  if (!/\/products\//.test(location.pathname)) return;

  function euro(cents) {
    cents = Number(cents) || 0;
    var s = (cents / 100).toFixed(2).split('.');
    s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '€' + s[0] + ',' + s[1];
  }

  // Sommige varianten bevatten meerdere eenheden (bv. Witbrood 2000 gr = 5 broden).
  // De stacked-snippet zet per variant het aantal eenheden + de labels op .lk-stack,
  // zodat we bij een variantwissel ook het tegel-label ("10 broden") en de
  // stukprijs-regel ("p/brood") kunnen bijwerken i.p.v. alleen de bedragen.
  function packInfo(variantId) {
    var stack = document.querySelector('.lk-stack');
    var info = { units: 1, singular: '', plural: '', hide: false, note: '' };
    if (!stack) return info;
    info.singular = stack.getAttribute('data-lk-singular') || '';
    info.plural = stack.getAttribute('data-lk-plural') || '';
    try {
      var map = JSON.parse(stack.getAttribute('data-lk-units') || '{}');
      var u = Number(map[String(variantId)]);
      if (u >= 1) info.units = u;
    } catch (e) {}
    try {
      var hideMap = JSON.parse(stack.getAttribute('data-lk-hide') || '{}');
      info.hide = Number(hideMap[String(variantId)]) === 1;
    } catch (e) {}
    try {
      var noteMap = JSON.parse(stack.getAttribute('data-lk-notes') || '{}');
      info.note = String(noteMap[String(variantId)] || '').trim();
    } catch (e) {}
    return info;
  }

  // Varianten met custom.volumekorting_verbergen tonen geen tegels maar een
  // enkele stukprijs-regel. De sectie wordt bij een variantwissel niet opnieuw
  // gerenderd, dus we wisselen hier zelf tussen beide blokken.
  function applyVisibility(info, unitCents) {
    var wrap = document.querySelector('[data-lk-qb]');
    if (!wrap) return;
    var stackEl = wrap.querySelector('.lk-stack');
    var banner = wrap.querySelector('[data-lk-banner]');
    var single = wrap.querySelector('[data-lk-single]');
    if (single) {
      var priceEl = single.querySelector('[data-lk-single-price]');
      var unitWordEl = single.querySelector('[data-lk-single-unit]');
      if (priceEl) priceEl.textContent = euro(Math.round(unitCents / info.units));
      if (unitWordEl && info.singular) unitWordEl.textContent = info.singular;
      var noteEl = single.querySelector('[data-lk-single-note]');
      if (noteEl) noteEl.textContent = info.note ? ' — ' + info.note : '';
      single.hidden = !info.hide;
    }
    if (stackEl) stackEl.hidden = info.hide;
    if (banner) banner.hidden = info.hide;
    if (info.hide) {
      // Geen tegels zichtbaar: val terug op 1 stuk, zodat een eerder gekozen
      // aantal (bv. 4 zakjes van 400 g) niet stilletjes blijft staan.
      var qtyScope = wrap.closest('.product-form__quantity') || wrap.closest('.product__info-container') || document;
      var qtyInput = qtyScope.querySelector('input[name="quantity"]');
      if (qtyInput && Number(qtyInput.value) > 1) {
        qtyInput.value = 1;
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  function recompute(unitCents, variantId) {
    unitCents = Number(unitCents);
    if (isNaN(unitCents)) return;
    var info = packInfo(variantId);
    var suffix = info.units > 1 && info.singular ? 'p/' + info.singular : 'p/s';
    applyVisibility(info, unitCents);
    document.querySelectorAll('.lk-stack__row').forEach(function (row) {
      var qty = Number(row.dataset.qty) || 1;
      var pct = Number(row.dataset.pct) || 0;
      var discountAmount = Math.round(unitCents * pct / 100);
      var discountedUnit = unitCents - discountAmount;
      var total = discountedUnit * qty;
      var perUnit = Math.round(discountedUnit / info.units);
      var totalEl = row.querySelector('.lk-stack__total');
      var unitEl = row.querySelector('.lk-stack__unit');
      var labelEl = row.querySelector('.lk-stack__label');
      if (totalEl) totalEl.textContent = euro(total);
      if (unitEl) unitEl.textContent = euro(perUnit) + ' ' + suffix;
      if (labelEl && info.singular && info.plural) {
        var n = qty * info.units;
        labelEl.textContent = n + ' ' + (n === 1 ? info.singular : info.plural);
      }
    });
  }

  function hook() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.variantChange) {
      return false;
    }
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (event && event.data && event.data.variant && typeof event.data.variant.price !== 'undefined') {
        recompute(event.data.variant.price, event.data.variant.id);
      }
    });
    return true;
  }

  function start() {
    if (!document.querySelector('.lk-stack__row')) return;
    if (hook()) return;
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (hook() || tries > 20) clearInterval(iv);
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* Lisa Kookt - productnaam + gekozen variant in de mobiele sticky koopbalk (14-08-2026).
   De balk toonde alleen een stepper en "In winkelwagen"; zodra je voorbij het koopblok
   scrollt staan er alleen nog andere producten in beeld, waardoor onduidelijk is bij
   welk product die knop hoort - en bij producten met varianten ook welke variant. */
(function () {
  'use strict';
  if (!/\/products\//.test(location.pathname)) return;

  var CSS = [
    '@media screen and (max-width: 767px){',
    '.lk-sticky-atc{flex-wrap:wrap;padding-top:9px !important;row-gap:11px !important;}',
    '.lk-sticky-atc__ctx{display:flex;align-items:center;gap:8px;flex:1 0 100%;min-width:0;}',
    '.lk-sticky-atc__thumb{width:28px;height:28px;border-radius:5px;object-fit:cover;flex:0 0 auto;background:#fff;}',
    '.lk-sticky-atc__label{flex:0 1 auto;font-size:13px;line-height:1.25;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:0;}',
    '.lk-sticky-atc__name{font-weight:600;}',
    '.lk-sticky-atc__variant{font-weight:400;opacity:.7;}',
    '.lk-sticky-atc__revbtn{display:inline-flex;align-items:center;gap:3px;flex:0 0 auto;margin-left:6px;cursor:pointer;background:none;border:0;padding:2px 0;}',
    '.lk-sticky-atc__stars{position:relative;display:inline-block;font-size:14.4px;line-height:1;letter-spacing:1px;white-space:nowrap;}',
    '.lk-sticky-atc__stars-bg{color:rgba(0,0,0,.18);}',
    '.lk-sticky-atc__stars-fg{position:absolute;left:0;top:0;display:inline-block;overflow:hidden;white-space:nowrap;color:#E2703A;}',
    '.lk-sticky-atc__revcount{font-size:12px;line-height:1;color:#E2703A;text-decoration:underline;text-underline-offset:2px;}',
    '@keyframes lk-atc-nudge{0%,100%{transform:scale(1);}30%{transform:scale(1.09);}60%{transform:scale(.98);}}',
    '.lk-sticky-atc__revbtn.lk-nudge{animation:lk-atc-nudge .7s ease-in-out 2;transform-origin:left center;}',
    '@media (prefers-reduced-motion: reduce){.lk-sticky-atc__revbtn.lk-nudge{animation:none;}}',
    /* Uitklapbaar paneel met de laatste beoordelingen, boven de balk. */
    '.lk-rev-back{position:fixed;inset:0;background:rgba(0,0,0,.35);z-index:399;}',
    '.lk-rev-sheet{position:absolute;left:0;right:0;bottom:100%;background:#fff;border-radius:12px 12px 0 0;box-shadow:0 -6px 20px rgba(0,0,0,.15);padding:12px 16px 14px;max-height:60vh;overflow:auto;-webkit-overflow-scrolling:touch;text-align:left;}',
    '.lk-rev-sheet[hidden],.lk-rev-back[hidden]{display:none !important;}',
    '.lk-rev-sheet__head{display:flex;align-items:center;justify-content:space-between;font-weight:600;font-size:14px;margin-bottom:8px;}',
    '.lk-rev-sheet__close{border:0;background:none;font-size:22px;line-height:1;padding:0 4px;color:rgba(0,0,0,.55);cursor:pointer;}',
    '.lk-rev-sheet__list{list-style:none;margin:0;padding:0;}',
    '.lk-rev{padding:10px 0;border-top:1px solid rgba(0,0,0,.08);}',
    '.lk-rev:first-child{border-top:0;padding-top:0;}',
    '.lk-rev__stars{position:relative;display:inline-block;font-size:13px;line-height:1;letter-spacing:1px;white-space:nowrap;}',
    '.lk-rev__stars-bg{color:rgba(0,0,0,.18);}',
    '.lk-rev__stars-fg{position:absolute;left:0;top:0;display:inline-block;overflow:hidden;white-space:nowrap;color:#E2703A;}',
    '.lk-rev__meta{display:block;margin-top:4px;font-size:11px;color:rgba(0,0,0,.55);}',
    '.lk-rev__title{display:block;margin-top:4px;font-size:13px;font-weight:600;}',
    '.lk-rev__body{margin:4px 0 0;font-size:13px;line-height:1.4;display:-webkit-box;-webkit-line-clamp:4;-webkit-box-orient:vertical;overflow:hidden;}',
    '.lk-rev-sheet__all{display:block;margin-top:10px;font-size:13px;font-weight:600;color:#E2703A;text-decoration:underline;}',
    '.lk-rev-sheet__empty{margin:0;font-size:13px;color:rgba(0,0,0,.55);}',
    /* Zichtbaarheid wordt hieronder door lk-atc-show bepaald; de themaklasse
       is-visible wordt bewust geneutraliseerd omdat die de balk al bij het laden
       toonde en zo met de volumekorting-tegels concurreerde. */
    /* !important is nodig: de themaregel voor .is-visible staat in een stylesheet
       in de body en komt dus na dit style-blok in de head. */
    '.lk-sticky-atc.is-visible{transform:translateY(115%) !important;opacity:0 !important;pointer-events:none !important;}',
    '.lk-sticky-atc.lk-atc-show,.lk-sticky-atc.is-visible.lk-atc-show{transform:translateY(0) !important;opacity:1 !important;pointer-events:auto !important;}',
    '}'
  ].join('');

  var els = null;

  function injectCss() {
    if (document.getElementById('lk-sticky-ctx-css')) return;
    var st = document.createElement('style');
    st.id = 'lk-sticky-ctx-css';
    st.textContent = CSS;
    document.head.appendChild(st);
  }

  function variantTitleFromDom(scope) {
    var picker = scope.querySelector('variant-selects');
    if (!picker) return '';
    var parts = [];
    picker.querySelectorAll('input[type="radio"]').forEach(function (i) {
      if (i.checked && i.value) parts.push(i.value);
    });
    picker.querySelectorAll('select').forEach(function (sel) {
      if (sel.value) parts.push(sel.value);
    });
    var title = parts.join(' / ').trim();
    return title.toLowerCase() === 'default title' ? '' : title;
  }

  // Bewust de hoofdfoto van het product, niet de variantfoto: het duimnagel is
  // 28px en dient alleen ter herkenning van het product; welke variant je toevoegt
  // staat er in tekst naast. Zo wisselt het plaatje ook niet mee met de tegelfoto's.
  // Het thema plakt bij producten met één variant de inhoud achter de <h1>
  // ("Lisa's Bruin brood bakmix (400 gram)"). In de balk willen we de kale
  // productnaam; de hoeveelheid hoort daar alleen te staan als er echt iets te
  // kiezen valt. De server-side JSON-LD bevat de schone naam.
  function productName(scope) {
    var nodes = document.querySelectorAll('script[type="application/ld+json"]');
    for (var i = 0; i < nodes.length; i++) {
      try {
        var data = JSON.parse(nodes[i].textContent);
        var list = Array.isArray(data)
          ? data
          : data['@graph'] && Array.isArray(data['@graph'])
          ? data['@graph']
          : [data];
        for (var j = 0; j < list.length; j++) {
          var o = list[j];
          if (o && o['@type'] === 'Product' && o.name) {
            return String(o.name).replace(/\s+/g, ' ').trim();
          }
        }
      } catch (e) {}
    }
    var h1 = scope.querySelector('.product__title h1') || scope.querySelector('h1');
    return h1 ? h1.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function initialImage(scope) {
    var src = '';
    var og = document.querySelector('meta[property="og:image"]');
    if (og && og.content) src = og.content;
    if (!src) {
      var img =
        scope.querySelector('.product__media-item.is-active img') ||
        scope.querySelector('.product__media-item img');
      src = (img && (img.currentSrc || img.getAttribute('src'))) || '';
    }
    if (src) {
      // og:image kan http:// zijn; op een https-pagina is dat mixed content.
      src = src.replace(/^http:\/\//i, 'https://');
    }
    if (src && !/[?&]width=/.test(src)) {
      src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=80';
    }
    return src;
  }

  function setVariant(text) {
    if (!els) return;
    els.varEl.textContent = text ? ' · ' + text : '';
  }

  // Onder dit aantal beoordelingen tonen we geen sterren: vijf sterren op basis van
  // één review wekt eerder wantrouwen dan vertrouwen. Wil je de drempel wijzigen,
  // pas dan alleen dit getal aan.
  var MIN_REVIEWS = 5;

  // Judge.me rendert de preview-badge server-side mee in het koopblok; daar staan
  // het gemiddelde en het aantal als data-attribuut, dus we hoeven niet op hun
  // script te wachten.
  function ratingInfo(scope) {
    var b =
      (scope && scope.querySelector('.jdgm-prev-badge[data-average-rating]')) ||
      document.querySelector('.jdgm-prev-badge[data-average-rating]') ||
      document.querySelector('[data-average-rating]');
    if (!b) return { value: 0, count: 0 };
    var v = parseFloat(b.getAttribute('data-average-rating'));
    var n = parseInt(b.getAttribute('data-number-of-reviews'), 10);
    if (!isFinite(v) || v <= 0) v = 0;
    if (!isFinite(n) || n < 0) n = 0;
    return { value: v > 5 ? 5 : v, count: n };
  }

  function renderStars(scope) {
    if (!els || !els.starsEl) return;
    var r = ratingInfo(scope);
    if (!r.value || r.count < MIN_REVIEWS) {
      els.revBtn.style.display = 'none';
      return;
    }
    els.revBtn.style.display = '';
    els.starsFg.style.width = (r.value / 5 * 100).toFixed(1) + '%';
    els.revBtn.setAttribute(
      'aria-label',
      r.value.toFixed(1).replace('.', ',') + ' van 5 sterren, ' + r.count +
        ' beoordelingen — bekijk de laatste beoordelingen'
    );
    els.count = r.count;
    els.revCount.textContent = '(' + r.count + ')';
  }

  // ---- Uitklapbaar paneel met de laatste beoordelingen ----------------------
  var REVIEWS_IN_SHEET = 3;
  var sheet = null;

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function txt(el) {
    return el && el.textContent ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  // De Judge.me-widget staat al op de pagina; we lezen de reviews daaruit in
  // plaats van een extra verzoek te doen. Sorteren op tijdstempel, nieuwste eerst.
  function latestReviews(limit) {
    var items = [].slice.call(document.querySelectorAll('.jdgm-rev')).map(function (r) {
      var ts = r.querySelector('.jdgm-rev__timestamp');
      var rating = r.querySelector('.jdgm-rev__rating');
      return {
        score: rating ? parseFloat(rating.getAttribute('data-score')) || 0 : 0,
        when: ts ? ts.getAttribute('data-content') || txt(ts) : '',
        label: txt(ts),
        author: txt(r.querySelector('.jdgm-rev__author')),
        title: txt(r.querySelector('.jdgm-rev__title')),
        body: txt(r.querySelector('.jdgm-rev__body')),
        verified: r.getAttribute('data-verified-buyer') === 'true'
      };
    });
    items.sort(function (a, b) {
      return a.when < b.when ? 1 : a.when > b.when ? -1 : 0;
    });
    return items.slice(0, limit);
  }

  function ensureSheet() {
    if (sheet) return sheet;
    var bar = document.querySelector('.lk-sticky-atc');
    if (!bar) return null;
    var back = document.createElement('div');
    back.className = 'lk-rev-back';
    back.hidden = true;
    back.addEventListener('click', closeSheet);
    document.body.appendChild(back);

    var el = document.createElement('div');
    el.className = 'lk-rev-sheet';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-label', 'Laatste beoordelingen');
    el.hidden = true;
    bar.appendChild(el);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSheet();
    });

    sheet = { el: el, back: back, filled: false };
    return sheet;
  }

  function fillSheet() {
    var s = ensureSheet();
    if (!s) return;
    var list = latestReviews(REVIEWS_IN_SHEET);
    var html =
      '<div class="lk-rev-sheet__head"><span>Laatste beoordelingen</span>' +
      '<button type="button" class="lk-rev-sheet__close" aria-label="Sluiten">×</button></div>';
    if (!list.length) {
      html += '<p class="lk-rev-sheet__empty">De beoordelingen worden geladen…</p>';
    } else {
      html += '<ul class="lk-rev-sheet__list">';
      list.forEach(function (r) {
        var meta = [];
        if (r.author) meta.push(esc(r.author));
        if (r.verified) meta.push('geverifieerde koper');
        if (r.label) meta.push(esc(r.label));
        html +=
          '<li class="lk-rev">' +
          '<span class="lk-rev__stars"><span class="lk-rev__stars-bg">★★★★★</span>' +
          '<span class="lk-rev__stars-fg" style="width:' + (r.score / 5 * 100).toFixed(1) + '%">★★★★★</span></span>' +
          '<span class="lk-rev__meta">' + meta.join(' · ') + '</span>' +
          (r.title ? '<span class="lk-rev__title">' + esc(r.title) + '</span>' : '') +
          (r.body ? '<p class="lk-rev__body">' + esc(r.body) + '</p>' : '') +
          '</li>';
      });
      html += '</ul>';
    }
    var n = els && els.count ? els.count : 0;
    html +=
      '<a class="lk-rev-sheet__all" href="#judgeme_product_reviews">' +
      (n ? 'Alle ' + n + ' beoordelingen bekijken' : 'Alle beoordelingen bekijken') +
      '</a>';
    s.el.innerHTML = html;
    s.el.querySelector('.lk-rev-sheet__close').addEventListener('click', closeSheet);
    s.el.querySelector('.lk-rev-sheet__all').addEventListener('click', function (e) {
      e.preventDefault();
      closeSheet();
      var target =
        document.querySelector('#judgeme_product_reviews') ||
        document.querySelector('.jdgm-review-widget');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    s.filled = list.length > 0;
  }

  function openSheet() {
    var s = ensureSheet();
    if (!s) return;
    fillSheet();
    s.el.hidden = false;
    s.back.hidden = false;
    if (els) els.revBtn.setAttribute('aria-expanded', 'true');
    // Judge.me kan de widget nog aan het opbouwen zijn; dan later nog eens vullen.
    if (!s.filled) setTimeout(function () { if (!s.el.hidden) fillSheet(); }, 1500);
  }

  function closeSheet() {
    if (!sheet) return;
    sheet.el.hidden = true;
    sheet.back.hidden = true;
    if (els) els.revBtn.setAttribute('aria-expanded', 'false');
  }

  function toggleSheet() {
    if (sheet && !sheet.el.hidden) closeSheet();
    else openSheet();
  }

  function build() {
    var bar = document.querySelector('.lk-sticky-atc');
    if (!bar || bar.querySelector('.lk-sticky-atc__ctx')) return;
    injectCss();
    var scope = bar.closest('section') || document;

    var ctx = document.createElement('div');
    ctx.className = 'lk-sticky-atc__ctx';

    var img = document.createElement('img');
    img.className = 'lk-sticky-atc__thumb';
    img.alt = '';
    img.setAttribute('aria-hidden', 'true');
    img.loading = 'lazy';

    var label = document.createElement('span');
    label.className = 'lk-sticky-atc__label';
    var nameEl = document.createElement('span');
    nameEl.className = 'lk-sticky-atc__name';
    var varEl = document.createElement('span');
    varEl.className = 'lk-sticky-atc__variant';
    label.appendChild(nameEl);
    label.appendChild(varEl);

    var src = initialImage(scope);
    if (src) {
      img.src = src;
      ctx.appendChild(img);
    }
    ctx.appendChild(label);
    bar.insertBefore(ctx, bar.firstChild);

    var stars = document.createElement('span');
    stars.className = 'lk-sticky-atc__stars';
    var starsBg = document.createElement('span');
    starsBg.className = 'lk-sticky-atc__stars-bg';
    starsBg.textContent = '★★★★★';
    var starsFg = document.createElement('span');
    starsFg.className = 'lk-sticky-atc__stars-fg';
    starsFg.textContent = '★★★★★';
    starsFg.setAttribute('aria-hidden', 'true');
    stars.appendChild(starsBg);
    stars.appendChild(starsFg);

    // De sterren zijn tikbaar: ze klappen de laatste beoordelingen uit.
    var revBtn = document.createElement('button');
    revBtn.type = 'button';
    revBtn.className = 'lk-sticky-atc__revbtn';
    revBtn.setAttribute('aria-expanded', 'false');
    var revCount = document.createElement('span');
    revCount.className = 'lk-sticky-atc__revcount';
    revBtn.appendChild(stars);
    revBtn.appendChild(revCount);
    revBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggleSheet();
    });
    ctx.appendChild(revBtn);

    nameEl.textContent = productName(scope);

    els = {
      img: img,
      nameEl: nameEl,
      varEl: varEl,
      starsEl: stars,
      starsFg: starsFg,
      revBtn: revBtn,
      revCount: revCount,
      count: 0
    };
    setVariant(variantTitleFromDom(scope));
    renderStars(scope);
    // Mocht de badge alsnog door het Judge.me-script worden vervangen: nog twee keer kijken.
    setTimeout(function () { renderStars(scope); }, 1500);
    setTimeout(function () { renderStars(scope); }, 4000);
  }

  // De balk hoort pas te verschijnen zodra de echte koopknop achter de sticky
  // header verdwijnt. Bovenaan de pagina mag hij niet concurreren met de
  // volumekorting-tegels.
  function headerOffset() {
    var h = document.querySelector('.section-header');
    if (!h) return 0;
    var pos = getComputedStyle(h).position;
    if (pos !== 'sticky' && pos !== 'fixed') return 0;
    var r = h.getBoundingClientRect();
    return r.bottom > 0 ? r.bottom : 0;
  }

  function updateVisibility() {
    var bar = document.querySelector('.lk-sticky-atc');
    if (!bar) return;
    var scope = bar.closest('section') || document;
    var btn =
      scope.querySelector('.pdp-qty-btn-row .product-form__submit') ||
      scope.querySelector('.product-form__submit') ||
      scope.querySelector('button[name="add"]');
    if (!btn) return;
    var r = btn.getBoundingClientRect();
    var show = r.bottom <= headerOffset() + 4;
    if (!show && sheet && !sheet.el.hidden) closeSheet();
    bar.classList.toggle('lk-atc-show', show);
    if (show) nudgeOnce();
  }

  // Eenmalig een zacht pulsje op de sterren zodra de balk voor het eerst
  // verschijnt, zodat zichtbaar wordt dat er iets te tikken valt.
  var nudged = false;
  function nudgeOnce() {
    if (nudged || !els || !els.revBtn) return;
    if (els.revBtn.style.display === 'none') return;
    nudged = true;
    setTimeout(function () {
      els.revBtn.classList.add('lk-nudge');
      setTimeout(function () { els.revBtn.classList.remove('lk-nudge'); }, 1800);
    }, 700);
  }

  function bindVisibility() {
    var queued = false;
    function onScroll() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        updateVisibility();
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    window.addEventListener('orientationchange', onScroll);
    document.addEventListener('shopify:section:load', onScroll);
    updateVisibility();
    setTimeout(updateVisibility, 800);
  }

  function hook() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.variantChange) {
      return false;
    }
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (!els || !event || !event.data || !event.data.variant) return;
      var v = event.data.variant;
      setVariant(v.title && v.title.toLowerCase() !== 'default title' ? v.title : '');
      closeSheet();
      updateVisibility();
    });
    return true;
  }

  function start() {
    build();
    if (!els) return;
    bindVisibility();
    if (hook()) return;
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (hook() || tries > 20) clearInterval(iv);
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
/* ---- Reviewtitels inkorten (11-09-2026) ----------------------------------
   De bundelreviews heten "Over de <product> uit dit pakket". Te lang, zowel in
   de reviewlijst als in het paneel bij de sticky koopknop. Allebei lezen ze
   dezelfde Judge.me-titels uit de DOM, dus hier opschonen is genoeg. De
   observer vangt het herladen bij paginering af. Weghalen zodra de titels in
   Judge.me zelf zijn aangepast. */
(function () {
  var WEG = /\s*uit dit pakket\s*$/i;
  var bezig = false;

  function schoon(root) {
    if (bezig) return;
    bezig = true;
    var titels = (root || document).querySelectorAll('.jdgm-rev__title');
    for (var i = 0; i < titels.length; i++) {
      var oud = titels[i].textContent;
      var nieuw = oud.replace(/\s+/g, ' ').trim().replace(WEG, '');
      if (nieuw !== oud) titels[i].textContent = nieuw;
    }
    bezig = false;
  }

  function start() {
    schoon(document);
    if (!window.MutationObserver) return;
    var widget = document.querySelector('.jdgm-review-widget') || document.body;
    new MutationObserver(function () { schoon(widget); }).observe(widget, {
      childList: true, subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();